<template>
  <div
    :class="bem({
      singleOption: props.options?.length === 1,
      '8ko-only': is8KOOnly
    })"
  >
    <LensTechOption
      v-for="(option, index) in props.options"
      :key="index"
      :option="option"
      :active-option="props.activeOption"
      :selected="activeOption?.tech === option.tech"
      :extended-layout="is8KOOnly"
      :error="props.error"
      @selected="emits('selected', option)"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  options: Array<any>
  activeOption: object
  error: boolean
  customisedProduct: any
}

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  activeOption: () => ({}),
  error: false,
})

const is8KOOnly = computed(() => {
  return props.options.length === 2 &&
    props.options.every((option) => {
      return option.tech === '8ko' || option.tech === '8kop'
    })
})

const emits = defineEmits(['selected'])

const bem = useBEM('CoreLensTechOptions')
</script>

<style lang="postcss" scoped>
.CoreLensTechOptions {
  @apply flex flex-col gap-3;

  &--8ko-only {
    @apply grid grid-cols-2 gap-3;
  }
}

.CoreLensTechOptions--single-option {
  grid-template-columns: 1fr;
}
</style>
